module.exports = ".fline {\n    fill: none;\n    stroke-width: 2;\n}\n\n.errorline {\n    stroke: #EF5656;\n    stroke-dasharray: 2,2;\n}\n\n.errorcap {\n    stroke: #EF5656;\n    stroke-width: 2px;\n}\n\n.control-menu:hover {\n    cursor: pointer;\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/projects/project/plots/multi-graph/multi-graph.component.css
// module id = ./src/app/projects/project/plots/multi-graph/multi-graph.component.css
// module chunks = main